import { IBridgeOptions } from './interface'

/**
 * 是容器事件，仅在原生运行下有效，如离线包 <br>
 * 页面从前台进入后台时触发 <br>
 * 当A视图以打开新容器的方式打开B时，B视图如果监听了 viewDisappear 事件，并且B视图关闭重新回到A视图时，此时的B视图的 viewDisappear 监听代码会执行。<br>
 * 参考 http://document.lightyy.com/zh-cn/api/olight-event.html#viewdisappear
 *
 * @param {IBridgeOptions} { success, fail, complete }
 */
function viewDisappearSync({ success, fail, complete }: IBridgeOptions) {
  if (window.LightJSBridge) {
    window.LightJSBridge.onPageDisappear = () => {
      success && success()
      complete && complete()
    }
  } else {
    fail && fail()
    complete && complete()
  }
}

/**
 * 是容器事件，仅在原生运行下有效，如离线包 <br>
 * 页面从前台进入后台时触发 <br>
 * 当A视图以打开新容器的方式打开B时，B视图如果监听了 viewDisappear 事件，并且B视图关闭重新回到A视图时，此时的B视图的 viewDisappear 监听代码会执行。<br>
 * 参考 http://document.lightyy.com/zh-cn/api/olight-event.html#viewdisappear
 * 一个异步接口，支持 Promise 化使用
 * @returns
 */
function viewDisappear() {
  return new Promise((resolve, reject) => {
    if (window.LightJSBridge) {
      window.LightJSBridge.onPageDisappear = () => {
        resolve()
      }
    } else {
      reject('window.LightJSBridge 对象不存在')
    }
  })
}

export { viewDisappearSync }
